import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "../data/repository";

function PasswordReset() {
    const [id, setId] = useState("");
    const [studentName, setStudentName] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setId("");
        setStudentName("");
        // Show the "Registering" message and hide the submit button
        setIsSubmitting(true);
        try {
            // Calling an API endpoint for password reset:
            await sendPasswordResetEmail(id, studentName);

            // Display success message or navigate to login page
            setSuccessMessage("Password reset email sent successfully! Please check your spam if email not recieved.");

            // Show the "Registering" message and hide the submit button
            setIsSubmitting(false);

            // Redirect user to login page after 3 seconds
            setTimeout(() => {
                history("/Sign-in");
            }, 6000); // 6000 milliseconds = 6 seconds

        } catch (error) {
            // Show the "Registering" message and hide the submit button
            setIsSubmitting(false);
            setErrorMessage("Failed to send password reset email. Please try again. Make sure you enter correct ID and Name.");
        }
    };

    const handleInputChange = (event) => {
        setErrorMessage("");
        setId(event.target.value);
    };

    const handleNameInputChange = (event) => {
        setErrorMessage("");
        setStudentName(event.target.value);
    };

    return (
        <div>
            <h2 className="text-center mb-3" style={{ padding: "50px 20px 0 20px", color: "#112c3f" }}>Forgot Password</h2>

            {errorMessage && <div className="alert alert-danger text-center" style={{ margin: "20px" }}>{errorMessage}</div>}
            {successMessage && <div className="alert alert-success text-center" style={{ margin: "20px" }}>{successMessage}</div>}
            <form className="login-form" onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "0 auto" }}>
                <div className="form-group">
                    <label htmlFor="id">Enter your ID:</label>
                    <input
                        type="text"
                        className="form-control"
                        id="id"
                        name="id"
                        placeholder="Enter your ID"
                        value={id}
                        onChange={handleInputChange}
                        autoComplete="username"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="id">Enter your Student Name:</label>
                    <input
                        type="text"
                        className="form-control"
                        id="studentName"
                        name="studentName"
                        placeholder="Enter your Student Name"
                        value={studentName}
                        onChange={handleNameInputChange}
                        autoComplete="name"
                        required
                    />
                </div>
                <div className="text-center">
                    {!isSubmitting && <button type="submit" className="btn btn-custom">Submit</button>}
                    {isSubmitting && <em style={{}}>Please Wait - Sending Email...</em>}
                </div>

            </form>
        </div>

    );
}

export default PasswordReset;